import axios from 'axios'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import './assets/markdown.css'
import { API_URL } from './config/config.js'
import router from './router'
import { setupFontAwesome } from './plugins/fontawesome'
import i18n from './i18n'

// 创建应用实例
const app = createApp(App)

// 创建Pinia实例
const pinia = createPinia()

// 使用插件
app.use(pinia)
app.use(router)
setupFontAwesome(app)

// 设置axios默认配置 - 优先使用config.js配置
axios.defaults.baseURL = API_URL

// 初始化认证状态
import { useAuthStore } from './stores/auth.js'

// 在应用挂载前初始化认证状态
const authStore = useAuthStore()
authStore.initializeAuth()

// 挂载应用
app.use(i18n);
app.mount('#app')
